























import Component from 'vue-class-component'
import { Hooks } from '@/shared/interfaces/hooks'
import Vue from 'vue'
import { DragAndDropService } from '@/shared/services/drop-file/drag-and-drop-service'
import { Injector } from '@/config/dependency-injection'
import { DragAndDropHandler } from '@/shared/services/drop-file/drag-and-drop-handler'
import { loggerFor } from '@/shared/utils/logger'
import RespondecoBlock from '@/shared/components/respondeco-block.vue'
import { Prop } from 'vue-property-decorator'
import { RejectedFile } from '@/shared/models/rejected-file'

@Component({
  name: 'respondeco-drop-area',
  components: { RespondecoBlock },
})
export default class RespondecoDropArea extends Vue implements Hooks {
  @Prop({
    default: () => [/image.(gif|jpeg|png)/],
    type: Array,
  })
  public readonly allowedFileType!: RegExp[]

  @Prop({
    // 8 MB is the default maximum file size
    default: () => 8 * 1024 * 1024,
    type: Number,
  })
  public readonly maxFileSize!: number

  public dropArea = false
  public numberOfFiles = 0

  private dragAndDropService = Injector.get(DragAndDropService)
  private logger = loggerFor('DropArea')

  private dragAndDropHandler: DragAndDropHandler = {
    dragenter: event => {
      this.logger.debug('dragenter')

      this.showDropArea(event.dataTransfer?.items?.length || 1)
    },
  }

  public beforeDestroy(): void {
    this.dragAndDropService.removeHandler(this.dragAndDropHandler)
  }

  public mounted() {
    this.dragAndDropService.addHandler(this.dragAndDropHandler)
  }

  /**
   * Call the DragAndDropService with the given dragend event
   */
  public emitDragLeave(event: DragEvent): void {
    this.logger.debug('dragleave', event.target)

    this.dragAndDropService.handleDragLeave(event)

    this.hideDropArea()
  }

  /**
   * Call the DragAndDropService with the given DragEvent
   */
  public emitDrop(event: DragEvent): void {
    this.logger.debug('drop')

    const fileList = this.dragAndDropService.handleDrop(event)

    if (fileList) {
      const rejectedFiles: RejectedFile[] = []
      const acceptedFiles: File[] = []

      for (const file of fileList) {
        if (this.exceedsSize(file) === true) {
          rejectedFiles.push({
            file,
            reason: 'tooLarge',
          })
        } else if (this.isAllowed(file) === false) {
          rejectedFiles.push({
            file,
            reason: 'wrongFileType',
          })
        } else {
          acceptedFiles.push(file)
        }
      }

      if (rejectedFiles.length > 0) {
        this.$emit('rejected', rejectedFiles)
      }

      this.$emit('drop', acceptedFiles)
    }

    this.hideDropArea()
  }

  private exceedsSize(file: File): boolean {
    return file.size >= this.maxFileSize
  }

  private hideDropArea(): void {
    this.$set(this, 'dropArea', false)
    this.$set(this, 'numberOfFiles', 0)
  }

  private isAllowed(file: File): boolean {
    return this.allowedFileType.reduce((a: boolean, b) => a || b.test(file.type), false)
  }

  private showDropArea(number: number): void {
    this.$set(this, 'dropArea', true)
    this.$set(this, 'numberOfFiles', number)
  }
}
